import type { GroupBuying } from '@/types/database/groupBuying';

export const GroupBuyingOrdersContextDefaultValue: GroupBuying[] = [
  {
    _id: '998877665544',
    itemName: '',
    status: '待上架',
    cost: [
      {
        type: '',
        amount: 0,
      },
    ],
    expirationTime: '',
    allergen: '',
    storageMethod: '',
    manufacturerName: '',
    manufacturerPhone: '',
    manufacturerAddress: '',
    itemIntroduction: '',
    itemSpec: '',
    establishTime: 0,
    startTime: 0,
    endTime: 0,
    closingTime: 0,
    notice: '',
    note: '',
    imgUrl: '',
    createdTime: 0,
    minimumAmount: 0,
    maximumAmount: 0,
  },
];
